import React from 'react';

/**
 * Sticky bottom bar with title, price hint, and CTA button.
 * Shows on all viewports (most impactful on mobile).
 *
 * Props:
 *   title     - e.g. "Car AC Repair"
 *   priceHint - e.g. "From ₹1,999 · 30-Day Warranty"
 *   btnLabel  - e.g. "Book Now"
 *   btnHref   - link target (anchor or route)
 */
const StickyMobileCTA = ({ title, priceHint, btnLabel = 'Book Now', btnHref = '#' }) => {
  return (
    <div className="rr-sticky-bar">
      <div>
        <div className="rr-sticky-bar__title">{title}</div>
        {priceHint && <div className="rr-sticky-bar__price">{priceHint}</div>}
      </div>
      <a href={btnHref} className="rr-sticky-bar__btn">
        {btnLabel}
      </a>
    </div>
  );
};

export default StickyMobileCTA;
